import { Injectable } from '@angular/core';
import { Observable, of, Subject, ReplaySubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';
import { AlarmGroupCount, RsmAlarmGrouping, AlarmGroup } from '../models/AlarmGroup';
import { PortService } from './port.service';
import * as _ from 'lodash';
import { group } from '@angular/animations';

const jsonHttpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AlarmGroupService {
  private rootAlarmGroupingURL = 'core-service/api/rsm-alarm-grouping';

 
  alarmGroups: RsmAlarmGrouping[] = []; //this is rsm site alarm group
  alarmGroupCounts:AlarmGroupCount[] = [];
  private _alarmGroupCounts$: ReplaySubject<AlarmGroupCount[]> = new ReplaySubject(1);
  public alarmGroupCounts$ = this._alarmGroupCounts$.asObservable();

  allRsmAlarmGrouping: RsmAlarmGrouping[] = []
  allRsmAlarmGroupingStore: RsmAlarmGrouping[] = []
  isSearchOn: boolean = false;

  constructor(private http: HttpClient, public snackBar: MatSnackBar) {

   }

   
   search(searchInput:string){

    this.allRsmAlarmGrouping = this.allRsmAlarmGroupingStore;
    this.allRsmAlarmGrouping = this.allRsmAlarmGrouping.filter(x=> x.group_name.toLowerCase().includes(searchInput.toLowerCase()));
}

  //Get all alarm groups in a site with count alarms
  getAlarmGroupCount(site_id: number) {
    this.http.get<[AlarmGroupCount]>('core-service/api/alarm-group/site/count?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('alarm groups count'))
    ).subscribe( (count:[AlarmGroupCount]) => {

      // Remove 'Other' gruop so we can sort and add it at the end
      // of the list.
      var otherIndex = -1;
      var otherItem = null;
      count.forEach( (group, index) => {
        if (group && group.rsm_alarm_grouping) {
          if (group.rsm_alarm_grouping.alarm_group_id==null) {
            otherItem = group;
            otherIndex = index;
          }
        }
      });
      if (otherIndex >= 0) {
        count.splice(otherIndex, 1);
      }
      // Sort on group name and add 'Other' back
      this.alarmGroupCounts = _.sortBy(count, ['rsm_alarm_grouping.group_name'])
      this.alarmGroupCounts.push(otherItem);

      this._alarmGroupCounts$.next(this.alarmGroupCounts);
    })
  }

  //all alarm groups in this site
  getAlarmGroupBySiteId(site_id: number) {
    this.alarmGroups = [];
     this.http.get<[RsmAlarmGrouping]>('core-service/api/alarm-group/site?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('alarm groups'))
      // ,
      // map(groups => {
      //   console.log('Pre sort ', groups)              
      //   return _.sortBy(groups, ['rsm_alarm_grouping.group_name'])
      // })
    ).subscribe(res=>{
      console.log('aladasdsadarm groups in site', res)     
      if(!res)
      return;

      this.alarmGroups = _.sortBy(res, ['rsm_alarm_grouping.group_name'])
      console.log('aladasdsadarm groups in site', this.alarmGroups)     

    })
  }


  getAllRsmAlarmGroups() { //used in group management getAlarmGroupBySiteId

    

     this.http.get<[AlarmGroupCount]>('core-service/api/rsm-alarm-grouping', jsonHttpOptions).pipe(
    catchError(this.handleError<any>('All alarm groups'))).subscribe(res => {
      this.allRsmAlarmGrouping = res;
      this.allRsmAlarmGroupingStore = res;
    })
}



  addSiteAlarmGroup(addGroupPayload: any): Observable<any> {
    return this.http.post<any>(this.rootAlarmGroupingURL, addGroupPayload, jsonHttpOptions).pipe(
      catchError(this.handleError<any>('Add site alarm group'))
    );
  }

  deleteSiteAlarmGroup(deleteGroupPayload: any): Observable<any> {
    let url = `${this.rootAlarmGroupingURL}/${deleteGroupPayload.site_id}/${deleteGroupPayload.alarm_group_id}`;
    return this.http.delete<any>(url,jsonHttpOptions).pipe(
      catchError(this.handleError<any>('Remove site alarm group'))
    );
  }


  deleteAlarmGroup(groupId: number): Observable<any> {
    var httpOptions = {
      body: {
        alarm_group_id: groupId
      },
      headers: {
        'Content-Type': "application/json;charset=utf-8"
      }
    }
    return this.http.delete('core-service/api/rsm-alarm-grouping?alarm_group_id='+groupId).pipe(
      catchError(this.handleError<any>('delete alarm group', 'error')));
  }

  updateAlarmGrouping(alarmGroup: RsmAlarmGrouping): Observable<any> {
    return this.http.put('core-service/api/rsm-alarm-grouping', alarmGroup).pipe(
      catchError(this.handleError<any>('update alarm group', 'error')));
  }

  updateSiteAlarmGroup(alarmGroup: AlarmGroup) : Observable<AlarmGroup> {

    //delete alarmGroup.rsm_alarm_grouping

    return this.http.put('core-service/api/alarm-group', alarmGroup).pipe(
      catchError(this.handleError<any>('update alarm group', 'error')));
  }

  createAlarmGroup(alarmGroup: any): Observable<any> {
    return this.http.post('core-service/api/rsm-alarm-grouping/addRsmAlarmGrouping', alarmGroup).pipe(
      catchError(this.handleError<any>('update alarm group', 'error')));
  }

  getAlarmGroupById(alarmGroupId: number) : Observable<RsmAlarmGrouping>{
    return this.http.get<RsmAlarmGrouping>('core-service/api/rsm-alarm-grouping/getById?alarm_group_id=' + alarmGroupId).pipe(
      catchError(this.handleError<any>('update alarm group', 'error')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.snackBar.open(`${operation} failed: ${error.message}`, '', {
        duration: 3000,
      });
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
